import React, { useMemo } from "react";
import Container from "../../../../CommonElements/Container";
import Countdown from "../../../../CommonElements/Countdown";
import {
  asIsoDate,
  formatStartDate,
  hasCompetitionStarted,
  resolveEndDateIso,
  turkeyEndOfDayIso,
} from "../../../../Constant/competition";
import { useCompetition } from "../../../../context/CompetitionContext";
import { useLanguage } from "../../../../context/LanguageContext";

const CountdownBar = () => {
  const { t } = useLanguage();
  const { competition } = useCompetition();

  const { showEnd, dateValue, targetDate } = useMemo(() => {
    const endIso = resolveEndDateIso(competition);
    const started = hasCompetitionStarted(competition.startDate);
    const useEnd = started && Boolean(endIso);
    const startIso = asIsoDate(competition.startDate);

    return {
      showEnd: useEnd,
      dateValue: formatStartDate(useEnd ? endIso : startIso || competition.startDate),
      targetDate: useEnd
        ? turkeyEndOfDayIso(endIso)
        : startIso
          ? `${startIso}T00:00:00+03:00`
          : competition.countdownTarget || "",
    };
  }, [competition]);

  return (
    <section className="countdown-bar">
      <Container>
        <div className="countdown-bar__inner">
          <div>
            <p className="countdown-bar__label">
              {t(showEnd ? "countdown.competitionEnds" : "countdown.competitionStart")}
            </p>
            <p className="countdown-bar__date">
              {t(showEnd ? "countdown.endsAt" : "countdown.startedAt", { date: dateValue })}
            </p>
          </div>
          <Countdown targetDate={targetDate} />
        </div>
      </Container>
    </section>
  );
};

export default CountdownBar;
